
import moment from 'moment';
import { useEffect, useState } from 'react';

import {
    authTargetTypes as _authTargetTypes,
    authTargetSystemRouteTypes as _authTargetSystemRouteTypes
} from './api/useAuth'

export const authTargetTypes = _authTargetTypes;
export const authTargetSystemRouteTypes = _authTargetSystemRouteTypes

const getStorageValue = (key) => (
    JSON.parse(localStorage.getItem(key))
)

const setStorageValue = (key, value) => (
    localStorage.setItem(key, JSON.stringify(value))
)

export function useAuthAccess(authTarget) {

    const [target, setTarget] = useState(authTarget);

    const sessionAccessKey = "accessSession";
    const [authData, setAuthData] = useState(getStorageValue(sessionAccessKey))

    const performLogin = ({ displayName, profile }) => {

        const {
            token,
            parent_user_id: parentUserId = '',
            account,
            user,
            user_locations: userLocations = [],
            location_zones: locationZones = [],
            roles = [],
            permissions = {},
            is_owner: isOwner = false,
            owner_id: ownerUserId = '',
        } = profile

        // console.log('profile, profile', profile)
        // console.log('user', user)

        let authData = {
            authType: target,
            displayName,
            userId: user?.id,
            token,
            profile: {
                parentUserId, // parent of the user id (if any)
                account, // logged in system account
                user, // logged in user profile
                locations: userLocations, // permission for locations access,
                zones: locationZones, // permission for zones access (for worker only),
                ownership: { // for the owner account 
                    isOwner: Boolean(isOwner),
                    userId: ownerUserId
                }
            },
            roles: {
                assignedRoles: roles,
                assignedPermissions: permissions
            },
            authDateTime: moment.now(),
            expireDateTime: moment().add(7, 'days')
        };

        setStorageValue(sessionAccessKey, authData)
        setAuthData(authData)

        return {
            authData
        };

    }

    const performLogout = (callback) => {
        setAuthData(null)
        setStorageValue(sessionAccessKey, null)

        if (callback) callback();

    }

    const checkIsLogin = () => {

        if (authData?.authType === authTarget) {
            return true;
        }

        return false;
    }

    const getAvailableLocations = () => {

        const { profile } = getStorageValue(sessionAccessKey) ? getStorageValue(sessionAccessKey) : {};

        // check if only workstation - get the location from the zones
        // if(authTarget === _authTargetTypes.workstation){
        //     const a = getAvailableZones();
        //     // console.log('a', a);
        //     let locations = [];
        //     a.forEach(element => {
        //         locations.push({

        //         })
        //     });
        //     return locations
        // }

        // for multiple locations
        return profile?.locations

    }

    const getAvailableZones = () => {

        const { profile } = getStorageValue(sessionAccessKey) ? getStorageValue(sessionAccessKey) : {};

        // for multiple locations
        return profile?.zones
    }

    const getRolePermissions = () => {

        return authData?.roles

    }

    const checkIsOwnerUser = () => {

        return Boolean(authData?.profile?.ownership?.isOwner)

    }

    useEffect(() => {

        // get local storage
        const savedSession = getStorageValue(sessionAccessKey) ? getStorageValue(sessionAccessKey) : {};

        if (savedSession?.authType) {
            setAuthData(savedSession)
        }

    }, [])

    return {
        authData,
        authTargetTypes,
        checkIsLogin,
        performLogin,
        performLogout,
        getAvailableLocations,
        getAvailableZones,
        getRolePermissions,
        checkIsOwnerUser
    }
}